export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getRentingTypeList: function getRentingTypeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/rent_type/get",
        method: "get",
        params: data
      });
    },
    addRentingType: function addRentingType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/rent_type/add",
        method: "post",
        data: data
      });
    },
    updateRentingType: function updateRentingType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/rent_type/update",
        method: "post",
        data: data
      });
    }
  };
});